import { EventEmitter } from 'events';
import { updateDeviceInfo } from '../actions/login.actions';
import { redirectOnNotification } from '../actions/notifications.actions';
import { LINKING_SERVICE } from '../constants';
import { redirectToRoute } from '../actions/common.actions';

export default class LinkingService extends EventEmitter {
    static store = {};

    static handleMessageFromNativeWebView = (message, store) => {
      if (!message || !store) { return; }
      let messageData = {};
      try {
        messageData = JSON.parse(message);
      } catch (err) {
        messageData = message || {};
      }

      switch (messageData.type) {
        case LINKING_SERVICE.DEVICE_TOKEN:
          store.dispatch(updateDeviceInfo(messageData.value));
          break;
        case LINKING_SERVICE.NOTIFICATION_DATA:
          store.dispatch(redirectOnNotification(messageData.value));
          break;
        case LINKING_SERVICE.GO_BACK:
          store.dispatch(redirectToRoute('goback'));
          break;
        default:
          break;
      }
    }

    static addEventListeners = (store) => {
      // React-native to webview bridge
      // for iOS
      window.addEventListener('message', (e) => {
        LinkingService.handleMessageFromNativeWebView(e.data, store);
      });

      // for Android
      document.addEventListener('message', (e) => {
        LinkingService.handleMessageFromNativeWebView(e.data, store);
      });
    }

    static removeEventListeners = () => {
      window.removeEventListener('message', (ev) => {});
      document.removeEventListener('message', (ev) => {});
    }

    static sendDataToWrapper = (messageObj) => {
      if (!messageObj) { return; }
      const webview = window.ReactNativeWebView;
      if (!webview) { return; }
      // webview to react-native bridge.
      webview.postMessage(JSON.stringify(messageObj));
    }
}
